import get from 'lodash/get'

class HttpLogger {
  logRequest({
    url,
    method,
    status,
    body,
    result
  }: {
    url: string
    method: string
    status: number
    body?: object
    result?: object
  }) {
    this.logMissingParamsToObjectFilter({ url, method, status, body, result })
  }

  private logMissingParamsToObjectFilter({
    url,
    method,
    status,
    body,
    result
  }: {
    url: string
    method: string
    status: number
    body?: object
    result?: object
  }) {
    if (!url.includes('/objects/_filter') || method !== 'POST' || !body) {
      return
    }

    const missingParams = this.getMissingParams(body)
    if (missingParams.length === 0) {
      return
    }

    console.warn('Missing params:', {
      missingParams,
      objectClass: this.getObjectClass(result),
      status,
      body
    })
  }

  private getMissingParams(body: object) {
    const missingParams: string[] = []
    const filterParams = ['skip_relations', 'skip_metadata', 'project_fields']

    filterParams.forEach((param) => {
      if (!body[param as keyof typeof body]) {
        missingParams.push(param)
      }
    })

    return missingParams
  }

  private getObjectClass(result?: object) {
    return (
      get(result, 'data.metadata.object_class.uuid_objectclass') ||
      '[Not returned]'
    )
  }
}

export default new HttpLogger()
